export default __webpack_public_path__ + "static/media/email.b09d3f64.svg";